import { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Field } from 'formik';
import { Collapse } from '@mui/material';
import { EmployeeSelectField } from '@features/employee-select';
import { $usersInfo } from '@features/tickets/models/ticket-assignees';
import { $mode, $ticket } from '../../models';
import { SectionHeader } from '../../molecules';
import { useStyles, styles } from '../detail/components/styles';

export const TicketAssigness: FC = () => {
  const { t } = useTranslation();
  const mode = useUnit($mode);
  const [expanded, setExpanded] = useState(true);
  const classes = useStyles({ external: false });
  const [usersInfo] = useUnit([$ticket, $usersInfo]);

  const handleExpanded = () => setExpanded(!expanded);

  return (
    <div className={classes.container}>
      <SectionHeader
        title={t('Performers')}
        isExpanded={expanded}
        onClick={handleExpanded}
      />
      <Collapse in={expanded} timeout="auto">
        <div className={classes.field} style={styles.fullWidth}>
          <Field
            key={usersInfo}
            label={t('Performer')}
            placeholder={t('SelectPerformer')}
            component={EmployeeSelectField}
            name="assignees"
            divider={false}
            isMulti
            mode={mode}
          />
        </div>
      </Collapse>
    </div>
  );
};
